import object from './object'
export default {
  object
}
